/*=============================================== ToastPage ===============================================*/

import { Toast } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const ToastPage = () => {
    const items: ItemType[] = [
        {
            title: "",
            intro: "",
            content: (
                <Toast
                    title="Title"
                    icon={{ name: "check-circle", color: "success" }}
                    withCloseButton
                >
                    Content
                </Toast>
            ),
            code: '<Toast title="Title" icon={{ name: "check-circle", color: "success" }} withCloseButton>\n    Content\n</Toast>\n',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "title",
            type: "string",
            required: true,
        },
        {
            subtitle: "maxWidth",
            type: "number or string",
        },
        {
            subtitle: "withCloseButton",
            intro: (
                <>
                    Using this prop as a <code>string</code> will change the{" "}
                    <code>close</code> icon. {commonProps.addIconCapital}
                </>
            ),
            type: "string or boolean",
        },
        {
            subtitle: "labelClose",
            type: "string",
            default: "Close",
        },
        "separator",
        {
            subtitle: "icon",
            type: "string or object",
        },
        {
            title: (
                <>
                    <code>icon</code> object
                </>
            ),
            subtitle: "name",
            type: "string",
            required: true,
        },
        {
            subtitle: "color",
            type: "string",
            possibleString: commonProps.allColors,
            default: "primary",
        },
        {
            subtitle: "size",
            type: "number or string",
            default: 24,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ToastPage
